import React from 'react'
import { Link } from 'react-router-dom'
import { useLocale } from '../contexts/LocaleContext'
import Reveal from './Reveal'

const pointKeys = ['assign', 'sessions', 'progress', 'feedback']

function CoachSection() {
  const { locale, t } = useLocale()
  const contactPath = locale === 'fr' ? '/fr/contact' : '/contact'

  return (
    <section id="coach" className="section">
      <div className="container coach-grid">
        <Reveal className="coach-copy">
          <div className="eyebrow">{t.coachSection.eyebrow}</div>
          <h2>{t.coachSection.title}</h2>
          <p className="lead">{t.coachSection.lead}</p>
          <p className="coach-cta-line">
            {t.coachSection.coachPrompt} <Link to={contactPath}>{t.coachSection.coachLink}</Link>
          </p>
        </Reveal>
        <ul className="coach-points">
          {pointKeys.map((key, i) => (
            <Reveal as="li" className="coach-point" key={key} delay={i * 0.08}>
              <span className="coach-point-num" aria-hidden="true">{String(i + 1).padStart(2, '0')}</span>
              <div>
                <h3>{t.coachSection.points[key].title}</h3>
                <p>{t.coachSection.points[key].description}</p>
              </div>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default CoachSection
